<template>
  <a-drawer width="45%" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form" :rules="rules">
      <a-form-model-item :label="$t('编号')" class="hide">
        <a-input v-model="form.id" readOnly />
      </a-form-model-item>
      <a-form-model-item :label="$t('用户ID')" class="hide">
        <a-input v-model="form.userId" readOnly />
      </a-form-model-item>
      <a-form-model-item :label="$t('渠道名称')" class="hide">
        <a-input v-model="form.channelName" readOnly />
      </a-form-model-item>
      <a-form-model-item :label="$t('渠道手机号')" class="hide">
        <a-input v-model="form.channelMobile" readOnly />
      </a-form-model-item>
      <a-form-model-item v-if="formType === 3" :label="$t('所属商家')" class="hide">
        <a-input :value="form.merchantName || form.merchantId" readOnly />
      </a-form-model-item>
      <a-form-model-item :label="$t('状态')" class="hide">
        <custom-dict-tag :options="customDict.AuditStatusEnum" :color="true" :color-array="['orange','green','red']" :value="form.status"/>
      </a-form-model-item>
      <a-form-model-item :label="$t('备注')" class="hide">
        <a-textarea v-model="form.remark" :auto-size="{ minRows: 2, maxRows: 4 }" readOnly />
      </a-form-model-item>
      <a-form-model-item v-if="formType === 2" :label="$t('所属商家')" prop="merchantId">
        <a-select
          v-model="form.merchantId"
          show-search
          option-filter-prop="children"
          :placeholder="$t('请选择')+$t('商家')"
          allow-clear
          style="width: 100%"
        >
          <a-select-option v-for="item in merchantList" :key="item.id" :value="item.id">
            {{ item.merchantName }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item v-if="formType === 2" :label="$t('是否审核通过')" prop="isPass">
        <a-radio-group v-model="form.isPass" button-style="solid">
          <a-radio-button v-for="(item, index) in customDict.TFEnum" :value="item.type" :key="index">
            {{ item.name }}
          </a-radio-button>
        </a-radio-group>
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button v-if="formType === 2" type="primary" :loading="submitLoading" @click="submitForm">
            {{ $t('保存') }}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{ formType === 2 ? $t('取消') : $t('关闭') }}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getInviteChannel, auditInviteChannel } from '@/api/user/inviteChannel'
import { listSelectMerchant } from '@/api/merchant/merchantMerchant'
import { mapGetters } from 'vuex'
import CustomDictTag from '@/components/DictCustomTag'

export default {
  name: 'CreateForm',
  components: {
    CustomDictTag
  },
  data () {
    return {
      labelCol: { span: 6 },
      wrapperCol: { span: 16 },
      submitLoading: false,
      formTitle: '',
      form: this.getDefaultForm(),
      // 2审核 3详情
      formType: 3,
      open: false,
      merchantList: [],
      rules: {
        isPass: [
          { required: true, message: '是否审核通过不能为空', trigger: 'change' }
        ],
        merchantId: [
          { validator: (rule, value, callback) => {
            if (this.form.isPass && !value) {
              callback(new Error('审核通过时必须选择商家'))
            } else {
              callback()
            }
          }, trigger: 'change' }
        ]
      }
    }
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  methods: {
    getDefaultForm () {
      return {
        id: null,
        userId: null,
        channelName: null,
        channelMobile: null,
        inviteUserCount: null,
        inviteUserPayCount: null,
        inviteOrderCount: null,
        inviteOrderAmount: null,
        inviteUserRechargeCount: null,
        inviteRechargeCount: null,
        inviteRechargeAmount: null,
        lastUpdateTime: null,
        status: null,
        remark: null,
        createTime: null,
        merchantId: undefined,
        merchantName: null,
        isPass: true
      }
    },
    onClose () {
      this.cancel()
    },
    cancel () {
      this.open = false
      this.reset()
    },
    reset () {
      this.formType = 3
      this.form = this.getDefaultForm()
    },
    getFormId (row, ids) {
      if (row && row.id) {
        return row.id
      }
      return Array.isArray(ids) ? ids[0] : ids
    },
    openForm (row, ids, formType, title) {
      this.reset()
      this.formType = formType
      const id = this.getFormId(row, ids)
      const loadDetail = getInviteChannel({ id: id }).then(response => {
        this.form = Object.assign(this.getDefaultForm(), response.data, { isPass: true })
        if (!this.form.merchantId) {
          this.form.merchantId = undefined
        }
        this.open = true
        this.formTitle = title
      })
      if (formType === 2) {
        Promise.all([loadDetail, this.loadMerchantList()])
      } else {
        loadDetail
      }
    },
    loadMerchantList () {
      return listSelectMerchant({}).then(response => {
        this.merchantList = response.data || []
      })
    },
    /** 审核 */
    handleUpdate (row, ids) {
      this.openForm(row, ids, 2, this.$t('审核'))
    },
    /** 详情 */
    handleDetail (row, ids) {
      this.openForm(row, ids, 3, this.$t('详情'))
    },
    submitForm () {
      this.$refs.form.validate(valid => {
        if (!valid) {
          return false
        }
        this.submitLoading = true
        auditInviteChannel({
          id: this.form.id,
          isPass: this.form.isPass,
          merchantId: this.form.merchantId
        }).then(() => {
          this.$message.success(this.$t('审核成功'), 3)
          this.open = false
          this.$emit('ok')
        }).finally(() => {
          this.submitLoading = false
        })
      })
    }
  }
}
</script>
<style scoped lang="less">
.hide {
  /deep/ .ant-input {
    border: 0 !important;
  }
  /deep/ .ant-input:focus {
    box-shadow: none !important;
  }
}
</style>
